import { isUserAllowed } from '@lumapps/permissions';
import { createSelector } from '@lumapps/redux/reselect';

export const isUserAdmin = isUserAllowed();

export const canManageMedia = isUserAllowed('canManageMedia');
export const canCreateMedia = isUserAllowed('canCreateMedia');
export const canDeleteMedia = isUserAllowed('canDeleteMedia');
export const canReadMedia = isUserAllowed('canReadMedia');

export const canAccessMediaTags = createSelector(
    canManageMedia,
    canCreateMedia,
    isUserAdmin,
    (canManageMedia, canCreateMedia, isUserAdmin) => canCreateMedia || canManageMedia || isUserAdmin,
);

export const canAccessMediaLibrary = createSelector(
    canManageMedia,
    canDeleteMedia,
    canCreateMedia,
    isUserAdmin,
    (canManageMedia, canDeleteMedia, canCreateMedia, isUserAdmin) =>
        canDeleteMedia || canCreateMedia || canManageMedia || isUserAdmin,
);
